/** Stable attachment reference in MCP Markdown. Display Markdown keeps filenames. */

export const FILE_REF_PREFIX = 'cs-file://';

const FILE_REF_RE = /^cs-file:\/\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i;

export function fileRefUrl(fileId: string): string {
  return `${FILE_REF_PREFIX}${fileId}`;
}

export function parseFileRef(url: string): string | null {
  const match = FILE_REF_RE.exec(url.trim());
  return match?.[1] ?? null;
}
